import type { Glyph } from "./types";

export const ArrowRightIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M27.016 7.293C27.352 6.926 27.921 6.901 28.288 7.236L46.467 23.858C46.654 24.028 46.76 24.269 46.76 24.522C46.76 24.775 46.654 25.017 46.467 25.187L28.288 41.809C27.921 42.144 27.351 42.119 27.016 41.753C26.681 41.386 26.706 40.816 27.073 40.481L43.542 25.422L4.17 25.422C3.673 25.422 3.27 25.019 3.27 24.522C3.27 24.025 3.673 23.623 4.17 23.623L43.542 23.623L27.073 8.564C26.706 8.229 26.681 7.659 27.016 7.293Z" />
  </svg>
);

export default ArrowRightIcon;
